/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightMedium } = typography;
const { borderColor } = colors;
const { borderWidth } = borders;

// Redesign: 16px semibold title with a bottom hairline.
const dialogTitle = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(16)} ${pxToRem(20)}`,
      fontSize: size.md,
      fontWeight: fontWeightMedium,
      borderBottom: `${borderWidth[1]} solid ${borderColor.main}`,
    },
  },
};

export default dialogTitle;
